import React from "react";

// SVG icon list large switch block using the svgs
// Icon list can be extended by adding additional switch statements
// Change fill colour in each SVG to set default colour
// The SVG id's must be renamed to prevent collisions
// The orignal svgs are in assets/images/icon-svgs they will need the namespace fixing to use in React
// Originals kept for reference

const SvgIcons = props => {
  /*eslint-disable */
  switch (props.icon) {
    /*eslint-enable */
    case "arrowUp":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-up"
          >
            <line x1="12" y1="19" x2="12" y2="5" />
            <polyline points="5 12 12 5 19 12" />
          </svg>
        </div>
      );
    case "arrowDown":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-down"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <polyline points="19 12 12 19 5 12" />
          </svg>
        </div>
      );
    case "arrowRight":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-right"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </div>
      );
    case "arrowLeft":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-left"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </div>
      );
    case "magnifier":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-search"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </div>
      );
    case "menu":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
          >
            <path d="M21 11h-18c-0.6 0-1 0.4-1 1s0.4 1 1 1h18c0.6 0 1-0.4 1-1s-0.4-1-1-1z" />
            <path d="M3 7h18c0.6 0 1-0.4 1-1s-0.4-1-1-1h-18c-0.6 0-1 0.4-1 1s0.4 1 1 1z" />
            <path d="M21 17h-18c-0.6 0-1 0.4-1 1s0.4 1 1 1h18c0.6 0 1-0.4 1-1s-0.4-1-1-1z" />
          </svg>
        </div>
      );

    case "plus":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-plus"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </div>
      );
    case "cross":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-x"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </div>
      );
    case "calendar":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-calendar"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        </div>
      );
    case "group":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-aperture"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="14.31" y1="8" x2="20.05" y2="17.94" />
            <line x1="9.69" y1="8" x2="21.17" y2="8" />
            <line x1="7.38" y1="12" x2="13.12" y2="2.06" />
            <line x1="9.69" y1="16" x2="3.95" y2="6.06" />
            <line x1="14.31" y1="16" x2="2.83" y2="16" />
            <line x1="16.62" y1="12" x2="10.88" y2="21.94" />
          </svg>
        </div>
      );
    case "list":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-list"
          >
            <line x1="8" y1="6" x2="21" y2="6" />
            <line x1="8" y1="12" x2="21" y2="12" />
            <line x1="8" y1="18" x2="21" y2="18" />
            <line x1="3" y1="6" x2="3" y2="6" />
            <line x1="3" y1="12" x2="3" y2="12" />
            <line x1="3" y1="18" x2="3" y2="18" />
          </svg>
        </div>
      );
    case "compare":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-trello"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <rect x="7" y="7" width="3" height="9" />
            <rect x="14" y="7" width="3" height="5" />
          </svg>
        </div>
      );
    case "sendTo":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-external-link"
          >
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
        </div>
      );
    case "branch":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-git-branch"
          >
            <line x1="6" y1="3" x2="6" y2="15" />
            <circle cx="18" cy="6" r="3" />
            <circle cx="6" cy="18" r="3" />
            <path d="M18 9a9 9 0 0 1-9 9" />
          </svg>
        </div>
      );
    case "apple":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="28"
            viewBox="0 0 22 28"
          >
            <path d="M21.766 18.984c-0.391 1.234-1.016 2.547-1.922 3.906-1.344 2.047-2.688 3.063-4.016 3.063-0.531 0-1.25-0.172-2.188-0.5-0.922-0.344-1.719-0.5-2.359-0.5-0.625 0-1.375 0.172-2.219 0.516-0.859 0.359-1.547 0.531-2.063 0.531-1.609 0-3.156-1.359-4.703-4.047-1.516-2.688-2.297-5.297-2.297-7.859 0-2.391 0.594-4.328 1.766-5.844 1.172-1.5 2.641-2.25 4.438-2.25 0.766 0 1.672 0.156 2.766 0.469 1.078 0.313 1.797 0.469 2.156 0.469 0.453 0 1.203-0.172 2.234-0.531 1.031-0.344 1.937-0.531 2.703-0.531 1.25 0 2.359 0.344 3.328 1.016 0.547 0.375 1.094 0.906 1.625 1.563-0.812 0.688-1.406 1.297-1.781 1.844-0.672 0.969-1.016 2.047-1.016 3.234 0 1.281 0.359 2.453 1.078 3.484s1.547 1.687 2.469 1.969zM15.891 0.656c0 0.641-0.156 1.359-0.453 2.125-0.313 0.781-0.797 1.5-1.453 2.156-0.562 0.562-1.125 0.938-1.687 1.125-0.359 0.109-0.891 0.203-1.625 0.266 0.031-1.547 0.438-2.891 1.219-4.016s2.094-1.891 3.906-2.312c0.031 0.141 0.063 0.25 0.078 0.344 0 0.109 0.016 0.203 0.016 0.313z" />
          </svg>
        </div>
      );
    case "windows":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="28"
            viewBox="0 0 26 28"
          >
            <path d="M10.656 15.719v10.172l-10.656-1.469v-8.703h10.656zM10.656 4.109v10.297h-10.656v-8.828zM26 15.719v12.281l-14.172-1.953v-10.328h14.172zM26 2v12.406h-14.172v-10.453z" />
          </svg>
        </div>
      );
    case "linux":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="28"
            viewBox="0 0 25 28"
          >
            <path d="M10.359 6.422v0c-0.313 0.031-0.203 0.313-0.375 0.313-0.156 0.016-0.125-0.344 0.375-0.313zM11.719 6.641c-0.156 0.047-0.172-0.25-0.453-0.172v0c0.453-0.203 0.609 0.109 0.453 0.172zM6.234 13.312c-0.141-0.047-0.109 0.234-0.25 0.453-0.109 0.203-0.391 0.359-0.172 0.391v0c0.078 0.016 0.297-0.172 0.391-0.391 0.078-0.266 0.156-0.406 0.031-0.453zM19.594 18.922c0-0.281-0.609-0.547-0.859-0.656 0.422-1.406 0.234-1.969-0.047-3.297-0.219-1-1.141-2.359-1.859-2.781 0.187 0.156 0.531 0.609 0.891 1.297 0.625 1.172 1.25 2.906 0.844 4.344-0.156 0.562-0.531 0.641-0.781 0.656-1.094 0.125-0.453-1.313-0.906-3.266-0.516-2.188-1.047-2.344-1.172-2.516-0.641-2.844-1.344-2.562-1.547-3.625-0.172-0.953 0.828-1.734-0.531-2-0.422-0.078-1.016-0.5-1.25-0.531s-0.359-1.578 0.516-1.625c0.859-0.063 1.016 0.969 0.859 1.375-0.25 0.406 0.016 0.562 0.438 0.422 0.344-0.109 0.125-1.016 0.203-1.141-0.219-1.313-0.766-1.5-1.328-1.609-2.156 0.172-1.188 2.547-1.406 2.328-0.313-0.328-1.219-0.031-1.219-0.234 0.016-1.219-0.391-1.922-0.953-1.937-0.625-0.016-0.875 0.859-0.906 1.359-0.047 0.469 0.266 1.453 0.5 1.375 0.156-0.047 0.422-0.359 0.141-0.344-0.141 0-0.359-0.344-0.391-0.75-0.016-0.406 0.141-0.812 0.672-0.797 0.609 0.016 0.609 1.234 0.547 1.281-0.203 0.141-0.453 0.406-0.484 0.453-0.203 0.328-0.594 0.422-0.75 0.562-0.266 0.281-0.328 0.594-0.125 0.703 0.719 0.406 0.484 0.875 1.484 0.906 0.656 0.031 1.141-0.094 1.594-0.234 0.344-0.109 1.453-0.344 1.687-0.75 0.109-0.172 0.234-0.172 0.313-0.125 0.156 0.078 0.187 0.375-0.203 0.469-0.547 0.156-1.094 0.453-1.594 0.641-0.484 0.203-0.641 0.281-1.094 0.359-1.031 0.187-1.797-0.375-1.109 0.297 0.234 0.219 0.453 0.359 1.047 0.344 1.313-0.047 2.766-1.625 2.906-0.922 0.031 0.156-0.406 0.344-0.75 0.516-1.219 0.594-2.078 1.781-2.859 1.375-0.703-0.375-1.406-2.109-1.391-1.328 0.016 1.203-1.578 2.266-0.844 3.641-0.484 0.125-1.563 2.422-1.719 3.609-0.094 0.688 0.063 1.531-0.109 2-0.234 0.688-1.297-0.656-0.953-2.297 0.063-0.281 0-0.344-0.078-0.203-0.422 0.766-0.187 1.844 0.156 2.594 0.141 0.328 0.5 0.469 0.766 0.75 0.547 0.625 2.703 2.219 3.078 2.609 0.484 0.453 0.344 1.516-0.656 1.625v0c0.516 0.969 1.016 1.062 1 2.641 0.594-0.313 0.359-1 0.109-1.437-0.172-0.313-0.391-0.453-0.344-0.531 0.031-0.047 0.344-0.313 0.516-0.109 0.531 0.594 1.531 0.703 2.594 0.562 1.078-0.125 2.234-0.5 2.766-1.359 0.25-0.406 0.422-0.547 0.531-0.469 0.125 0.063 0.172 0.344 0.156 0.812-0.016 0.5-0.219 1.016-0.359 1.437-0.141 0.484-0.187 0.812 0.281 0.828 0.125-0.875 0.375-1.734 0.438-2.609 0.078-1-0.641-2.844 0.141-3.766 0.203-0.25 0.453-0.281 0.797-0.281 0.047-1.25 1.969-1.156 2.609-0.641zM9.781 6c0.063-0.391-0.125-0.672-0.219-0.703-0.187-0.047-0.156 0.234-0.063 0.203v0c0.063 0 0.141 0.094 0.109 0.234-0.031 0.187-0.016 0.313 0.125 0.313 0.016 0 0.047 0 0.047-0.047zM16.328 9.078c-0.063-0.297-0.281-0.187-0.531-0.344-0.297-0.187-0.359-0.5-0.469-0.391v0c-0.328 0.359 0.406 1.109 0.719 1.172 0.187 0.031 0.328-0.219 0.281-0.438zM13.547 5.75c0.016-0.375-0.313-0.562-0.391-0.547-0.203 0.016-0.141 0.109-0.047 0.141v0c0.125 0.031 0.25 0.25 0.281 0.484 0 0.031 0.156-0.031 0.156-0.078zM14.391 2.109c0.016-0.078-0.187-0.172-0.328-0.281-0.125-0.125-0.25-0.234-0.375-0.234-0.313 0.031-0.156 0.359-0.203 0.516v0c-0.063 0.172-0.297 0.313-0.141 0.438 0.141 0.109 0.234-0.172 0.531-0.281 0.078-0.031 0.438 0.016 0.516-0.156zM23.219 23.063c1.922 1.188-0.719 2.172-1.859 2.75-0.891 0.453-2.078 1.453-2.516 1.875-0.328 0.313-1.687 0.469-2.453 0.078-0.891-0.453-0.422-1.172-1.797-1.219-0.688-0.016-1.359-0.016-2.031-0.016-0.594 0.016-1.188 0.047-1.797 0.063-2.063 0.047-2.266 1.375-3.594 1.328-0.906-0.031-2.047-0.75-4.016-1.156-1.375-0.281-2.703-0.359-2.984-0.969s0.344-1.297 0.391-1.891c0.047-0.797-0.594-1.875-0.125-2.281 0.406-0.359 1.266-0.094 1.828-0.406 0.594-0.344 0.844-0.609 0.844-1.344 0.219 0.75-0.016 1.359-0.5 1.656-0.297 0.187-0.844 0.281-1.297 0.234-0.359-0.031-0.578 0.016-0.672 0.156-0.141 0.172-0.094 0.484 0.078 0.891s0.375 0.672 0.344 1.172c-0.016 0.5-0.578 1.094-0.484 1.516 0.031 0.156 0.187 0.297 0.578 0.406 0.625 0.172 1.766 0.344 2.875 0.609 1.234 0.313 2.516 0.875 3.313 0.766 2.375-0.328 1.016-2.875 0.641-3.484v0c-2.016-3.156-3.344-5.219-4.406-4.406-0.266 0.219-0.281-0.531-0.266-0.828 0.047-1.031 0.562-1.406 0.875-2.203 0.594-1.516 1.047-3.25 1.953-4.141 0.672-0.875 1.734-2.297 1.937-3.047-0.172-1.625-0.219-3.344-0.25-4.844-0.031-1.609 0.219-3.016 2.031-4 0.438-0.234 1.016-0.328 1.625-0.328 1.078-0.016 2.281 0.297 3.047 0.859 1.219 0.906 1.984 2.828 1.891 4.203-0.063 1.078 0.125 2.188 0.469 3.344 0.406 1.359 1.047 2.312 2.078 3.406 1.234 1.313 2.203 3.891 2.484 5.531 0.25 1.531-0.094 2.484-0.422 2.531-0.5 0.078-0.812 1.656-2.375 1.594-1-0.047-1.094-0.641-1.375-1.156-0.453-0.797-0.906-0.547-1.078 0.297-0.094 0.422-0.031 1.047 0.109 1.516 0.281 0.984 0.187 1.906 0.016 3.047-0.328 2.156 1.516 2.562 2.75 1.531 1.219-1.016 1.484-1.172 3.016-1.703 2.328-0.797 1.547-1.5 0.297-1.922-1.125-0.375-1.172-2.266-0.766-2.625 0.094 2.031 1.156 2.328 1.594 2.609z" />
          </svg>
        </div>
      );
    case "info":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-info"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12" y2="8" />
          </svg>
        </div>
      );

    case "activity":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-activity"
          >
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
        </div>
      );

    case "close":
      return (
        <div className="svg-icon-holder">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-x"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </div>
      );

    default:
      return null;
  }
};

export default SvgIcons;
